export const DEVELOPER_EMAILS = ["dev@revnus.com"];

export function isDeveloperEmail(email: string | null | undefined) {
  return DEVELOPER_EMAILS.includes((email ?? "").toLowerCase());
}
